import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { useNotify } from '../../../provider/NotificationProvider'
import { useForm } from 'react-hook-form'
import { FormValues, loginFields, schema } from '../../../config/fields/login'
import { yupResolver } from '@hookform/resolvers/yup'
import { useMutation } from '@tanstack/react-query'
import { postLogin } from '../../../api/auth'
import { useAuth } from '../../../provider/AuthProvider'
type PasswordField = 'password' | 'confirmPassword'

const Login = () => {
  const { login, loginWithGoogle } = useAuth()
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  })

  const notify = useNotify()
  const route = all_routes
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
  })

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))
  }

  const loginMutation = useMutation({
    mutationFn: async (data: FormValues) => {
      return postLogin(data)
    },
    onSuccess: (data) => {
      if (!data?.token || !data?.user) {
        notify.error({
          message: 'Login gagal',
          description: 'Respon tidak valid dari server, silahkan coba lagi',
        })
        return
      }

      notify.success({
        message: 'Login berhasil',
      })
      login(data)
      navigate(all_routes.home)
    },
    onError: (err: any) => {
      notify.error({
        message: 'Login gagal',
        description: err?.response?.data?.message || 'Terjadi kesalahan.',
      })
    },
  })

  const onSubmit = (data: FormValues) => {
    loginMutation.mutate(data)
  }
  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        <div className="login-content">
          <div className="row">
            {/* Login Banner */}
            <div className="col-lg-6 login-bg d-none d-lg-flex p-5">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="/assets/img/login.webp"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div
                  className="mentor-course text-center mt-5"
                  style={{ color: '#1E344C' }}
                >
                  <h3 className="mb-2" style={{ color: '#1E344C' }}>
                    Assalamu’alaikum,
                    <br />
                    <span className="" style={{ color: '#1E344C' }}>
                      Welcome to Jadipraktisi!
                    </span>
                  </h3>
                  <p className="" style={{ color: '#1E344C' }}>
                    Bismillah, perjalanan karirmu akan dimulai dari sini, masuk
                    sekarang!
                  </p>
                </div>
              </div>
            </div>
            {/* /Login Banner */}
            <div className="col-lg-6 login-wrap-bg">
              {/* Login */}
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="w-100">
                    <div className="d-flex align-items-center justify-content-between login-header">
                      <Link to={route.home} className="link-1">
                        <ImageWithBasePath
                          src="/assets/img/logo-color.webp"
                          className="img-fluid"
                          alt="Logo"
                          width={250}
                        />
                      </Link>
                    </div>
                    <h1 className="fs-32 fw-bold topic">
                      Sign into Your Account
                    </h1>
                    <form
                      onSubmit={handleSubmit(onSubmit)}
                      className="mb-3 pb-3"
                    >
                      {loginFields.map(([fieldName, field]) => (
                        <div key={fieldName} className="mb-3 position-relative">
                          <label className="form-label">
                            {field.label}
                            {field.required && (
                              <span className="text-danger ms-1">*</span>
                            )}
                          </label>

                          <div
                            className="position-relative"
                            id={
                              fieldName === 'password'
                                ? 'passwordInput'
                                : undefined
                            }
                          >
                            <input
                              type={
                                fieldName === 'password' &&
                                passwordVisibility.password
                                  ? 'text'
                                  : field.type
                              }
                              className={`form-control form-control-lg ${
                                fieldName === 'password' ? 'pass-input' : ''
                              }`}
                              placeholder={field.placeholder}
                              {...register(fieldName)}
                            />

                            {fieldName === 'email' && (
                              <span>
                                <i className="isax isax-sms input-icon text-gray-7 fs-14" />
                              </span>
                            )}

                            {fieldName === 'password' && (
                              <span
                                className={`isax toggle-passwords fs-14 ${
                                  passwordVisibility.password
                                    ? 'isax-eye'
                                    : 'isax-eye-slash'
                                }`}
                                onClick={() =>
                                  togglePasswordVisibility('password')
                                }
                              ></span>
                            )}
                          </div>

                          {errors[fieldName] && (
                            <small className="text-danger d-block mt-1">
                              {errors[fieldName]?.message}
                            </small>
                          )}
                        </div>
                      ))}
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="">
                          <Link to={route.forgotpassword} className="link-2">
                            Forgot Password ?
                          </Link>
                        </div>
                      </div>
                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-secondary btn-lg d-block w-100"
                          disabled={loginMutation.isPending}
                        >
                          {loginMutation.isPending ? 'Loading...' : 'Login'}{' '}
                          <i className="isax isax-arrow-right-3 ms-1" />
                        </button>
                      </div>
                    </form>
                    {/* <div className="d-flex align-items-center justify-content-center or fs-14 mb-3">
                      Or
                    </div>
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      <div
                        onClick={loginWithGoogle}
                        className="btn btn-light me-2"
                      >
                        <ImageWithBasePath
                          src="/assets/img/icons/google.svg"
                          alt="img"
                          className="me-2"
                        />
                        Google
                      </div>
                    </div> */}
                    <div className="fs-14 fw-normal d-flex align-items-center justify-content-center">
                      Don't you have an account?
                      <Link to={route.register} className="link-2 ms-1">
                        {' '}
                        Sign up
                      </Link>
                    </div>
                    {/* /Login */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  )
}

export default Login
